export default __webpack_public_path__ + "static/media/ReversePlayIconWhite.1423972c.svg";